module.exports = __webpack_public_path__ + "img/DAB-Profile-Ken-Sommer.517bffd6.png";